module.exports = __webpack_public_path__ + "img/recyleContent.b54996a2.png";